// extracted by mini-css-extract-plugin
export default {"count-down-time":"otp-button_count-down-time__14Txg","button":"otp-button_button__-ZzLs"};